<template>
  <v-container fluid>
    <div>
      <span class="display-2">Zosuvy</span>
      <span class="subtitle">&nbsp;&nbsp;v{{ version }}</span>
    </div>
    <p>
      informačný systém Čiastkového monitorovacieho systému – Geologické
      faktory,
      <br />Podsystém 01 Zosuvy a iné svahové deformácie
    </p>
    <v-row>
      <v-col md="5" cols="12">
        <v-card>
          <v-card-title class="subheading font-weight-bold"
            >Štatistika údajov</v-card-title
          >
          <v-divider></v-divider>
          <v-list dense>
            <v-list-item v-for="(key, index) in stats" :key="index">
              <v-list-item-content>{{ key[0] }}:</v-list-item-content>
              <v-list-item-content class="align-end">{{
                key[1]
              }}</v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <l-map
        :zoom="zoom"
        :center="center"
        style="height: 600px; width: 100%; z-index: 0;"
      >
        <l-control-scale
          position="topright"
          :imperial="false"
          :metric="true"
        ></l-control-scale>
        <l-control position="bottomright">
          <v-img :src="require('../assets/nautical.svg')"></v-img>
        </l-control>
        <l-control-layers position="topright"></l-control-layers>
        <l-tile-layer
          v-for="tileProvider in tileProviders"
          :key="tileProvider.name"
          :name="tileProvider.name"
          :visible="tileProvider.visible"
          :url="tileProvider.url"
          :attribution="tileProvider.attribution"
          layer-type="base"
        />

        <template v-if="lokality.length > 0">
          <template v-for="lok in lokality">
            <l-marker
              v-if="lok.Lat != 0 && lok.Lng != 0"
              :lat-lng="[lok.Lat, lok.Lng]"
              :key="lok.ID"
            >
              <l-tooltip>{{ lok.Name }}</l-tooltip>
              <l-popup :options="lokPopupOptions">
                <h4>
                  <router-link
                    :to="{ name: 'lokalita', params: { id: lok.ID } }"
                    >{{ lok.Name }}</router-link
                  >
                </h4>
                <v-container>
                  <v-row dense v-if="lok.KU">
                    <v-col cols="3">
                      <b>Obec:</b>
                    </v-col>
                    <v-col>{{ lok.KU.NM4 }}</v-col>
                    <v-col cols="3">
                      <b>Okres:</b>
                    </v-col>
                    <v-col>{{ lok.KU.NM3 }}</v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="3">
                      <b>Počet bodov:</b>
                    </v-col>
                    <v-col>{{ lok.PocetBodov }}</v-col>
                  </v-row>
                  <v-row dense>
                    <v-col>{{ lok.Popis }}</v-col>
                  </v-row>
                  <v-row dense v-if="lok.Literatura.length > 0">
                    <v-col cols="2">
                      <b>Literatúra:</b>
                    </v-col>
                    <v-col>
                      <template v-for="lit in lok.Literatura">
                        <span :key="lit.ID">
                          {{ lit.Literatura }}
                          <br />
                        </span>
                      </template>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col>
                      <template v-for="meranie in merania">
                        <span
                          :key="meranie"
                          style="display: inline-block ;width: 50px"
                          v-if="getMeranieCountIconName(lok, meranie) !== ''"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on">
                                {{ getMeranieCountIconName(lok, meranie) }}
                              </v-icon>
                              {{ getMeranieCountPocet(lok, meranie) }}
                            </template>
                            <span>
                              {{ getMeranieCountText(lok, meranie) }}
                            </span>
                          </v-tooltip>
                        </span>
                      </template>
                      <span
                        style="display: inline-block ;width: 50px"
                        v-if="lok.SHMUCount > 0"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-weather-rainy</v-icon>
                            {{ lok.SHMUCount }}
                          </template>
                          <span>Počet SHMÚ staníc</span>
                        </v-tooltip>
                      </span>
                    </v-col>
                  </v-row>
                </v-container>
              </l-popup>
            </l-marker>
          </template>
        </template>
      </l-map>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-2">
        <v-simple-table dark dense class="clickableTable">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Názov</th>
                <th class="text-left">Obec</th>
                <th class="text-left">Okres</th>
                <th class="text-left">Merania</th>
                <th class="text-left">Počet bodov</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="lok in lokality"
                :key="lok.ID"
                @click="viewLokalita(lok)"
              >
                <td>{{ lok.Name }}</td>
                <td>{{ lok.KU.NM4 }}</td>
                <td>{{ lok.KU.NM3 }}</td>
                <td>
                  <template v-for="meranie in merania">
                    <span
                      :key="meranie"
                      style="display: inline-block ;width: 50px"
                      v-if="getMeranieCountIconName(lok, meranie) !== ''"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">
                            {{ getMeranieCountIconName(lok, meranie) }}
                          </v-icon>
                          {{ getMeranieCountPocet(lok, meranie) }}
                        </template>
                        <span>{{ getMeranieCountText(lok, meranie) }}</span>
                      </v-tooltip>
                    </span>
                  </template>
                  <span
                    style="display: inline-block ;width: 50px"
                    v-if="lok.SHMUCount > 0"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-weather-rainy</v-icon>
                        {{ lok.SHMUCount }}
                      </template>
                      <span>Počet SHMÚ staníc</span>
                    </v-tooltip>
                  </span>
                </td>
                <td>{{ lok.PocetBodov }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
      <v-overlay :value="loading">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-overlay>
    </v-row>
  </v-container>
</template>

<script>
import * as Enums from "../plugins/enums.js"
import * as L from "leaflet"
import {
  LMap,
  LMarker,
  LPopup,
  LControl,
  LControlLayers,
  LControlScale,
  LTileLayer,
  LTooltip
} from "vue2-leaflet"

export default {
  components: {
    LMap,
    LMarker,
    LPopup,
    LControl,
    LControlLayers,
    LControlScale,
    LTileLayer,
    LTooltip
  },

  data: () => ({
    loading: false,
    merania: Enums.TYPY,
    zoom: 8,
    center: [48.6, 19.7],
    bounds: null,
    lokality: [],
    tileProviders: [
      {
        name: "OpenTopoMap",
        visible: false,
        attribution:
          'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
      },
      {
        name: "FreeMapSk",
        visible: true,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, vizualization CC-By-SA 2.0 <a href="http://freemap.sk">Freemap.sk</a>',
        url: "https://{s}.freemap.sk/T/{z}/{x}/{y}.jpeg"
      },
      {
        name: "ZBGIS",
        visible: true,
        attribution:
          '&copy; <a target="_blank" href="https://zbgis.skgeodesy.sk/">ZBGIS</a>',
        url:
          "https://zbgis.skgeodesy.sk/zbgis/rest/services/ZBGIS/MapServer/tile/{z}/{y}/{x}"
      },
      {
        name: "OpenStreetMap",
        visible: true,
        attribution:
          '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      }
    ]
  }),

  computed: {
    logged: function() {
      return this.$store.state.logged
    },

    version: function() {
      return this.$store.state.version
    },

    stats: function() {
      return this.$store.state.stats
    },
    lokPopupOptions: function() {
      return {
        minWidth: 500,
        autoPanPaddingTopLeft: L.point(50, 10)
      }
    }
  },

  methods: {
    readLokality: async function() {
      try {
        let response = await this.$axios.get("/r/private/lokality")
        if (response.status === 200) {
          this.lokality = response.data
          this.lokality.sort(function(a, b) {
            if (a.Name < b.Name) {
              return -1
            } else if (a.Name > b.Name) {
              return 1
            }
            return 0
          })
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    getMeranieCountIconName: function(lokalita, meranie) {
      let ret = this.getMeranieCountItem(lokalita, meranie)
      return ret.iconName
    },
    getMeranieCountText: function(lokalita, meranie) {
      let ret = this.getMeranieCountItem(lokalita, meranie)
      return ret.text
    },
    getMeranieCountPocet: function(lokalita, meranie) {
      let ret = this.getMeranieCountItem(lokalita, meranie)
      return ret.pocet
    },
    getMeranieCountItem: function(lokalita, meranie) {
      let ret = Enums.getMeranieCountItem(lokalita, meranie)
      ret.text = "Počet bodov s vykonaným meraním: " + ret.text
      return ret
    },
    viewLokalita: function(lokalita) {
      this.$router.push({ name: "lokalita", params: { id: lokalita.ID } })
    }
  },

  mounted: async function() {
    console.log("home mounted")
    await this.$store.dispatch("fetchme", this.$axios)
    await this.readLokality()
    this.$nextTick(() => {
      //this.$refs.myMap.mapObject;
      /*
      L.tileLayer
        .wms("http://ows.mundialis.de/services/service?", {
          layers: "SRTM30-Colored-Hillshade"
        })
        .addTo(this.$refs.lmap)
        */
    })
  }
}
</script>
